// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5077":"e4ea7531","8654":"e4ea7531"}[chunkId] + ".chunk.css";
};